import { Helmet } from '@dr.pogodin/react-helmet';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import seoConfig, { SITE_URL } from './seoConfig';
import { getCanonicalUrl, normalizePathname } from './urlUtils';

const SEOHead = ({ title, description, keywords, noindex = false }) => {
  const { language } = useLanguage();
  const { pathname } = useLocation();

  const normalizedPathname = normalizePathname(pathname);
  const config = seoConfig[normalizedPathname];
  const meta = config ? config[language] : null;

  const pageTitle = title || (meta ? meta.title : 'كونكتو - Connecto');
  const pageDescription = description || (meta ? meta.description : '');
  const pageKeywords = keywords || (meta ? meta.keywords : '');
  const canonicalUrl = getCanonicalUrl(normalizedPathname);
  const locale = language === 'ar' ? 'ar_AR' : 'en_US';
  const dir = language === 'ar' ? 'rtl' : 'ltr';

  // Social Sharing Image
  const ogImage = `${SITE_URL}/og-image.jpg`;

  return (
    <Helmet>
      <html lang={language} dir={dir} />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      {pageKeywords ? <meta name="keywords" content={pageKeywords} /> : null}
      <link rel="canonical" href={canonicalUrl} />
      
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={pageTitle} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={language === 'ar' ? 'كونكتو' : 'Connecto'} />
      <meta property="og:locale" content={locale} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEOHead;
